<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAdminInfo } from '@/stores/useAdminInfo';
import { shouldUseConsultationWorkspaceHome } from '@/utils/consultantHome';

const route = useRoute();
const adminStore = useAdminInfo();

const breadcrumbs = computed(() => {
    adminStore.loadFromStorage();
    const items = [];

    if (shouldUseConsultationWorkspaceHome(adminStore.roles || [])) {
        items.push({
            title: '諮詢工作台',
            path: '/consultation-workspace/bookings'
        });
    } else {
        items.push({
            title: '儀表板',
            path: '/dashboard'
        });
    }

    let currentPath = '';
    route.matched.forEach((item) => {
        if (item.path === '/') return;
        if (item.redirect) return;

        if (item.meta?.title) {
            const segment = item.path.startsWith('/')
                ? item.path.slice(1)
                : item.path;
            if (segment === 'consultation-workspace') return;
            const path = segment.includes('/')
                ? `/${segment}`
                : `${currentPath}/${segment}`.replace(/\/+/g, '/');
            currentPath = path;
            if (items.some((b) => b.title === item.meta.title && b.path === path)) return;
            items.push({ title: item.meta.title, path });
        }
    });

    return items;
});
</script>

<template>
    <div class="mb-2">
        <a-breadcrumb class="text-sm">
            <a-breadcrumb-item
                v-for="(item, index) in breadcrumbs"
                :key="`${item.path}-${index}`"
            >
                <router-link
                    :to="item.path"
                    @click="
                        index === breadcrumbs.length - 1
                            ? $event.preventDefault()
                            : null
                    "
                >
                    <span
                        :class="{
                            'hover:text-[#8b6914]':
                                index !== breadcrumbs.length - 1,
                            'text-gray-400': index !== breadcrumbs.length - 1,
                            'text-[#8b6914] font-semibold':
                                index === breadcrumbs.length - 1,
                            'cursor-default': index === breadcrumbs.length - 1
                        }"
                    >
                        {{ item.title }}
                    </span>
                </router-link>
            </a-breadcrumb-item>
        </a-breadcrumb>
    </div>
</template>
